import { ConciergeCatalogRoute } from '@/lib/pages/concierge/ConciergeCatalogRoute';
import { getConciergeCatalogServerSideProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeCarCatalogPage } from '@/lib/entities/concierge/server-content';

import { InferGetServerSidePropsType } from 'next';

const PATH = '/concierge/car';

export default function ConciergeCarsPage({
  page,
  locale,
  pageSeo,
  listingRobots,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <ConciergeCatalogRoute
      page={page}
      locale={locale}
      pageSeo={pageSeo}
      listingRobots={listingRobots}
      path={PATH}
      keywords="car rental phuket concierge"
    />
  );
}

export const getServerSideProps = getConciergeCatalogServerSideProps(
  getConciergeCarCatalogPage,
  PATH
);
